exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pagination[data-v-97af39b6]{margin-top:20px;text-align:right}", "", {"version":3,"sources":["/workspace/src/views/order-review-target-management/pages/TargetProjectSettingTable.vue"],"names":[],"mappings":"AACA,6BAA6B,gBAAgB,gBAAgB,CAC5D","file":"TargetProjectSettingTable.vue","sourcesContent":["\n.pagination[data-v-97af39b6]{margin-top:20px;text-align:right\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-97af39b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order-review-target-management/pages/TargetProjectSettingTable.vue
// module id = 4655
// module chunks = 142